import './PullToRefreshIndicator.css';

const THRESHOLD = 80;

export default function PullToRefreshIndicator({ pullDistance, isRefreshing }) {
  const spinnerHeight = isRefreshing ? 40 : pullDistance;
  const spinProgress = Math.min(pullDistance / THRESHOLD, 1);
  const spinnerRotation = spinProgress * 360;

  return (
    <div
      className="pull-to-refresh-indicator"
      style={{
        height: `${spinnerHeight}px`,
        opacity: pullDistance > 0 || isRefreshing ? 1 : 0,
      }}
    >
      <div className="spinner-container">
        <div
          className={`spinner ${isRefreshing ? 'spinning' : ''}`}
          style={{
            transform: !isRefreshing ? `rotate(${spinnerRotation}deg)` : undefined,
          }}
        />
      </div>
    </div>
  );
}
